import { render } from "./cargar.vue?vue&type=template&id=7176a51e"
import script from "./cargar.vue?vue&type=script&lang=js"
export * from "./cargar.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__